import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import styles from "./MenuModal.module.scss";

import BusinessBar from "./BusinessBar";
import businessIcon from "../../../static/icons/businessIcon.svg";
import shippingIcon from "../../../static/icons/shipping-icon.svg";
import switchIcon from "../../../static/icons/switch-account.svg";
import termsIcon from "../../../static/icons/terms.svg";
import logoutIcon from "../../../static/icons/logout.svg";
import settingsIcon from "../../../static/icons/settings.svg";
import downArrowIcon from "../../../static/icons/downarrow.svg";

import { authActions } from "../../../actions/auth";
import { deleteUserInfo } from "../../../utils/localStorage";

const MenuModal = ({
  isOpen,
  onClose,
  setBusinessModal,
  onTermClicked,
  setIsSwitchProfileModalOpened,
  setIsSettingsClicked
}) => {
  const { userInfo } = useSelector((state) => state.authReducer);
  const dispatch = useDispatch();
  const history = useHistory();
  const modalRef = useRef(null);

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  const logoutHandler = () => {
    deleteUserInfo();
    dispatch(authActions.logout());
    history.push("/login");
    onClose();
  };

  const shippingHandler = () => {
    history.push(`/shipping/${userInfo.uid}/`);
    onClose();
  };

  const mainMenuItems = !userInfo?.business_role
    ? [
        {
          label: "Business",
          icon: businessIcon,
          onClick: () => setBusinessModal(true),
        },
        {
          label: "Accounts",
          icon: switchIcon,
          onClick: setIsSwitchProfileModalOpened,
        },
        {
          label: "Terms",
          icon: termsIcon,
          onClick: onTermClicked,
        },
        {
          label: "Settings",
          icon: settingsIcon,
          onClick: () => {
            onClose();
            setIsSettingsClicked();
          },
        },
      ]
    : [];

  const logoutMenuItem = {
    label: "Logout",
    icon: logoutIcon,
    onClick: logoutHandler,
  };

  return (
    <div className={styles.ModalWrap} onClick={onClose}>
      <div className={styles.MenuModal} onClick={(e) => e.stopPropagation()} ref={modalRef}>
        <div className={styles.MenuModalContent}>
          <img
            src={downArrowIcon}
            className={styles.dropDownArrow}
            onClick={onClose}
            alt="Close"
          />
          <div className={styles.MenuModalTitle}>MENU</div>

          <div className={styles.MenuModalGrid}>
            {userInfo?.business_role ? (
              <BusinessBar
                onClose={onClose}
                setSwitchProfileModal={setIsSwitchProfileModalOpened}
                onSettingsClicked={()=>{onClose();setIsSettingsClicked()}}
                onTermsClicked={onTermClicked}
                logoutHandler={logoutHandler}
              />
            ) : (
              <>
                <div className={styles.MenuModalMainItems}>
                  {mainMenuItems.map(({ label, icon, onClick }) => (
                    <div
                      key={label}
                      className={styles.MenuModalItemContainer}
                      onClick={onClick}
                      role="button"
                      tabIndex={0}
                      onKeyPress={(e) => {
                        if (e.key === "Enter" || e.key === " ") onClick();
                      }}
                    >
                      <div className={styles.MenuModalItemImageContainer}>
                        <img src={icon} alt={`${label} icon`} className={styles.MenuModalItemImage} />
                      </div>
                      <span className={styles.MenuModalItem}>{label}</span>
                    </div>
                  ))}
                </div>
                <div className={styles.MenuModalLogoutItem}>
                  <div
                    className={styles.MenuModalItemContainer}
                    onClick={logoutMenuItem.onClick}
                    role="button"
                    tabIndex={0}
                    onKeyPress={(e) => {
                      if (e.key === "Enter" || e.key === " ") logoutMenuItem.onClick();
                    }}
                  >
                    <div className={styles.MenuModalItemImageContainer}>
                      <img src={logoutMenuItem.icon} alt={`${logoutMenuItem.label} icon`} className={styles.MenuModalItemImage} />
                    </div>
                    <span className={styles.MenuModalItem}>{logoutMenuItem.label}</span>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(MenuModal);
